let PROVIDERS = {};
/* global __APP_PLATFORM__ */
if (__APP_PLATFORM__ === 'activate_iq') {
    PROVIDERS['activate_iq'] = require('./platforms/activate/provider').default;
} else if (__APP_PLATFORM__ === 'view_iq') {
    PROVIDERS['view_iq'] = require('./platforms/view/provider').default;
} else if (__APP_PLATFORM__ === 'reporting_iq') {
    PROVIDERS['reporting_iq'] = require('./platforms/reporting/provider').default;
}
export const getProviderForPlatform = (platformId) => PROVIDERS[platformId] || null;